module.exports = new __parcel__URL__("leaders_text.0b158bd6.png").toString();